import { createClient } from '@/shared/api';
import MIGRATE_AI_BEAT_FINAL_PATHS from '@/entities/report/api/mutations/migrateAiBeatFinalPaths';
import type {
  MigrateAiBeatFinalPathsMutation,
  MigrateAiBeatFinalPathsMutationVariables,
} from '@/shared/api/generated/graphql';

// TODO(ts): payload shape is defined by the AI service, not in this repo.
export type MigrateAiBeatFinalPaths = any;

/**
 * Resolves the migrated storage paths for a study's final beat files. Runs the migrateAiBeatFinalPaths query with the supplied variables and returns that field, tolerating a nullish response.
 *
 * @param variables - Query variables carrying the migration input.
 * @returns A promise resolving to the migrated beat final paths.
 */
const handleMigrateAiBeatFinalPaths = async (variables: { input: MigrateAiBeatFinalPaths }) => {
  const client = await createClient();
  const result = await client.query<
    MigrateAiBeatFinalPathsMutation,
    MigrateAiBeatFinalPathsMutationVariables
  >({
    query: MIGRATE_AI_BEAT_FINAL_PATHS,
    variables,
  });
  const { data } = result || {};
  return data?.migrateAiBeatFinalPaths;
};

export default handleMigrateAiBeatFinalPaths;
